import { createContext, useContext } from 'react';

/**
 * Shared by `Contact/ContactExecutive.js` (provides `addNewIndustry` only) and
 * `Company/CompanyTarget.js` (provides both `addNewIndustry` and `onFiscalErrorClose`).
 * Consumed by `CompanyDetailsTable.js` (`addNewIndustry`) and `FiscalYearTable.js`
 * (`onFiscalErrorClose`), which each destructure only the key they need.
 */
export const AddNewIndustryContext = createContext({});

export const useAddNewIndustryContext = () => useContext(AddNewIndustryContext);
